import { render, staticRenderFns } from "./BusinessTestimony.vue?vue&type=template&id=1398e7e7&scoped=true&"
import script from "./BusinessTestimony.vue?vue&type=script&lang=ts&"
export * from "./BusinessTestimony.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessTestimony.vue?vue&type=style&index=0&id=1398e7e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1398e7e7",
  null
  
)

export default component.exports